import { Link } from 'react-router-dom';

const footerLinks = {
  categories: {
    title: '精品分类',
    links: [
      { label: '时尚精品', path: '/category/fashion' },
      { label: '美妆护肤', path: '/category/beauty' },
      { label: '家居生活', path: '/category/home' },
      { label: '美食珍馐', path: '/category/food' },
      { label: '匠心工艺', path: '/category/craft' },
      { label: '亚洲奢品', path: '/category/luxury' },
    ],
  },
  about: {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '口碑评价', path: '/about#reputation' },
      { label: '联系我们', path: '/about#contact' },
    ],
  },
  support: {
    title: '客户服务',
    links: [
      { label: '购物指南', path: '/about' },
      { label: '配送说明', path: '/about' },
      { label: '退换政策', path: '/about' },
      { label: '常见问题', path: '/about' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-heading font-bold text-primary-400 tracking-wide">
                亚洲精品
              </span>
            </Link>
            <p className="text-foreground-300 text-sm leading-relaxed">
              甄选亚洲顶级品牌与匠心工艺，汇聚日韩、东南亚、中华等地区最具品质代表性的精品。每一件商品均经严格筛选，品质有保障。
            </p>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; 2026 亚洲精品 版权所有 | 品质甄选，匠心传承
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors duration-200" aria-label="小红书">
                <i className="ri-red-packet-line w-5 h-5 flex items-center justify-center"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}